import dates from "@/services/date";
import store from "@/store";
import company from "../../services/company";

let parseDate = function (value) {
  if (!value) {
    return;
  }

  return dates.jsonDateToLocaleDate(value, company.getLocaleFormat(store.state));
};

export default {
  install: function (Vue) {
    Vue.filter('parseDate', parseDate);
  }
}
